import BaseModal from './baseModal'

class ChangeCountryModal extends BaseModal {}
export default ChangeCountryModal
